import { Suspense, useCallback, useEffect } from 'react'
import { useRoutes, useLocation, useNavigate } from 'react-router-dom'
import { Spin } from 'antd'
import routes from './routes'

// 标识移动端
const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

function App() {
  const location = useLocation()
  const navigate = useNavigate()
  const router = useRoutes(routes)
  const turn = useCallback(() => {
    if (isMobile && !location.pathname.startsWith('/mobile'))
      navigate('mobile')
    else if (!isMobile && location.pathname.startsWith('/mobile'))
      navigate(location.pathname.replace('/mobile', ''))
  }, [location.pathname, navigate])
  useEffect(() => turn(), [turn])
  return (
    <Suspense fallback={<Spin />}>
      {router}
    </Suspense>
  );
}

export default App;
